import { Table, Header, SpaceBetween } from "@amzn/awsui-components-react";
import { useMemo } from "react";
import { getColumnDefinitions } from "./executionsTableConfig";
import { RedriveRequestItem } from "../../../types/common";

interface ExecutionsTableProps {
  items: RedriveRequestItem[];
  loading: boolean;
  onSelectExecution?: (executionId: string) => void;
}

export function ExecutionsTable({
  items,
  loading = false,
  onSelectExecution,
}: ExecutionsTableProps) {
  const columnDefinitions = useMemo(
    () => getColumnDefinitions(onSelectExecution),
    [onSelectExecution]
  );

  return (
    <Table
      resizableColumns
      stickyHeader
      columnDefinitions={columnDefinitions}
      items={items}
      loading={loading}
      loadingText="Loading resources"
      selectionType="multi"
      header={
        <Header
          variant="awsui-h1-sticky"
          counter={items.length > 0 ? `(${items.length})` : undefined}
        >
          Past Order Redrives
        </Header>
      }
      empty={
        <SpaceBetween size="m" alignItems="center">
          <div>No executions found</div>
        </SpaceBetween>
      }
    />
  );
}
